import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { gmapApi } from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

import { TisztaTiszaFunctions } from '../functions/TisztaTiszaFunctions';

Vue.component('GmapCluster', GmapCluster);
var language = TisztaTiszaFunctions.GetLocale();

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBQFgRrQl1J6NkI-qn_IoDxR_HwxPI-zjk',
    libraries: 'places',
    region: language,
    language: language,
  },
});
